import { buildPublicAppUrl } from '../config/hostApps';
import {
  CHECKOUT_ACTION_QUERY_PARAM,
  CHECKOUT_CHARGE_QUERY_PARAM,
  CHECKOUT_PLAN_QUERY_PARAM,
  CHECKOUT_REF_QUERY_PARAM,
} from '../pages/Checkout/checkout.constants';

/**
 * Link público do checkout. Origin/path decididos centralmente em
 * `buildPublicAppUrl`: subdomínio checkout.* em produção, /checkout em dev.
 */
export const buildCheckoutUrl = (
  planHash: string,
  actionHash?: string | null,
  refToken?: string | null,
): string => {
  const params = new URLSearchParams();
  params.set(CHECKOUT_PLAN_QUERY_PARAM, planHash.trim());

  if (actionHash?.trim()) {
    params.set(CHECKOUT_ACTION_QUERY_PARAM, actionHash.trim());
  }

  if (refToken?.trim()) {
    params.set(CHECKOUT_REF_QUERY_PARAM, refToken.trim());
  }

  return buildPublicAppUrl('checkout', { search: params.toString() });
};

export const buildCheckoutPlanUrl = (hash: string): string => buildCheckoutUrl(hash);

/** Link one-time de checkout resumido (já cliente Asaas). */
export const buildChargeCheckoutUrl = (planHash: string, chargeToken: string): string => {
  const params = new URLSearchParams();
  params.set(CHECKOUT_PLAN_QUERY_PARAM, planHash.trim());
  params.set(CHECKOUT_CHARGE_QUERY_PARAM, chargeToken.trim());
  return buildPublicAppUrl('checkout', { search: params.toString() });
};

